import { render, staticRenderFns } from "./EarlyWarning.vue?vue&type=template&id=0b8afda4&scoped=true"
import script from "./EarlyWarning.vue?vue&type=script&lang=js"
export * from "./EarlyWarning.vue?vue&type=script&lang=js"
import style0 from "./EarlyWarning.vue?vue&type=style&index=0&id=0b8afda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8afda4",
  null
  
)

export default component.exports